import React, {
  useState,
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
} from 'react';
import useHubFormState, { EditHubRHForm } from 'src/screens/Hubs/EditHub/useHubForm';
import { GLOBAL_FORM_ERROR } from 'src/components/Meeting/AddMeetingProvider';
import * as logger from 'src/utils/logger';

export interface HubRHFormStateType {
  rhForm: EditHubRHForm
  isSaving: boolean
  setIsSaving: React.Dispatch<React.SetStateAction<boolean>>
  formErrorMessage: string
}

interface InitialValues {
  hubId: string
}

export const HubRHFormStateContext = createContext<HubRHFormStateType | null>(null!)
HubRHFormStateContext.displayName = 'HubRHFormContext'

const HubRHFormStateProvider: React.FC<PropsWithChildren<InitialValues>> = (props) => {
  const { hubId, children } = props
  const [isSaving, setIsSaving] = useState<boolean>(false)
  const rhForm = useHubFormState({ hubId })
  const [formErrorMessage, setFormErrorMessage] = useState<string>('');
  const { errors } = rhForm.formState

  useEffect(() => {
    if (Object.keys(errors).length) {
      logger.hub.hubManagement.warn('Hub form error occurred', errors)
      setFormErrorMessage(GLOBAL_FORM_ERROR.too_small)
    } else setFormErrorMessage('')
  }, [errors])

  const contextValue: HubRHFormStateType = {
    rhForm,
    isSaving,
    setIsSaving,
    formErrorMessage,
  }

  return (
    <HubRHFormStateContext.Provider value={contextValue}>
      {children}
    </HubRHFormStateContext.Provider>
  )
}

HubRHFormStateProvider.displayName = 'HubRHFormStateProvider'
export const useHubRHFromState = () => {
  const context = useContext(HubRHFormStateContext)
  if (!context) {
    throw new Error('useHubRHFromState must be used within the HubRHFormStateProvider')
  }
  return context;
}

export default HubRHFormStateProvider
